import { services } from 'constants/services';
import * as React from 'react';
const CasesList = () => (React.createElement("div", { className: "service-fees" }, services.map((service) => (React.createElement("div", { key: service.id, className: "ser-fees-box " },
    React.createElement("div", { className: "fe-img" },
        React.createElement("img", { src: service.img, title: service.name, alt: service.name })),
    React.createElement("div", { className: "fees-text" },
        React.createElement("h4", null, service.name.toUpperCase()),
        React.createElement("p", null, service.text)))))));
export default CasesList;
